// extracted by mini-css-extract-plugin
export default {"bids":"LandingHow2_bids__zbL6b","body":"LandingHow2_body__lyK2R"};